// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-modal-content {
  padding: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-modal-content .semi-modal-body {
  height: 100%;
  padding: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-modal-content button.semi-modal-close {
  position: absolute;
  top: 28px;
  right: 20px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-tabs-bar.semi-tabs-bar-line.semi-tabs-bar-top {
  padding: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-tabs-bar.semi-tabs-bar-line.semi-tabs-bar-top .semi-tabs-tab.semi-tabs-tab-line {
  border-bottom: none;
  margin: 0;
  padding: 28px 24px 20px;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-tabs-bar.semi-tabs-bar-line.semi-tabs-bar-top .semi-tabs-tab.semi-tabs-tab-line.semi-tabs-tab-active {
  color: var(--light-usage-primary-color-primary, #4d53e8);
  border-bottom: none;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-tabs-bar.semi-tabs-bar-line.semi-tabs-bar-top .semi-tabs-tab.semi-tabs-tab-line:not(:first-child):before {
  background-color: var(--light-usage-border-color-border, rgba(28, 29, 35, .12));
  content: "";
  width: 1px;
  height: 24px;
  position: absolute;
  top: 28px;
  left: 0;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-tabs-bar.semi-tabs-bar-line.semi-tabs-bar-top .semi-tabs-bar-extra {
  height: 72px;
  line-height: 72px;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-tabs-pane-motion-overlay {
  height: 100%;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .semi-spin-children {
  height: 100%;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__tabs-l6L4uk {
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  display: flex;
  overflow-y: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N .\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__tab-pane-Q9cdDf {
  height: 100%;
  overflow-y: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__close-btn-_Nk0mO {
  z-index: 1;
  position: absolute;
  top: 28px;
  right: 25px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-tabs-modal": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N`,
	"uiTabsModal": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__ui-tabs-modal-mjhL6N`,
	"tabs": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__tabs-l6L4uk`,
	"tab-pane": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__tab-pane-Q9cdDf`,
	"tabPane": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__tab-pane-Q9cdDf`,
	"close-btn": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__close-btn-_Nk0mO`,
	"closeBtn": `------packages-components-bot-semi-src-components-ui-modal-ui-tabs-modal-index-module__close-btn-_Nk0mO`
};
export default ___CSS_LOADER_EXPORT___;
